import React, { useState } from 'react';
import logo from '../assets/logo.png';
import './Header.css';

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="header">
      <div className="container header-container">
        <div className="logo-container">
          <a href="/">
            <img src={logo} alt="Tri-Bay Electric Logo" className="logo" />
          </a>
        </div>

        <a href="tel:4083920014" className="phone-link">
          <span className="phone-icon">📞</span>
          <span className="phone-number">408-392-0014</span>
        </a>

        <button
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>

        <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <a href="#about" className="nav-link" onClick={() => setMenuOpen(false)}>About Us</a>
            </li>
            <li className="nav-item">
              <a href="#who-we-serve" className="nav-link" onClick={() => setMenuOpen(false)}>Who We Serve</a>
            </li>
            <li className="nav-item">
              <a href="#services" className="nav-link" onClick={() => setMenuOpen(false)}>Services</a>
            </li>
            <li className="nav-item">
              <a href="#estimation" className="nav-link" onClick={() => setMenuOpen(false)}>Estimation</a>
            </li>
            <li className="nav-item">
              <a href="#contact" className="nav-link" onClick={() => setMenuOpen(false)}>Contact</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header; 